export default () => ({
    visible: false,
    scrollFrame: null,
    handleScroll: null,
    footer: null,

    init() {
        this.footer = document.querySelector('.footer');
        this.handleScroll = () => this.scheduleSync();

        this.sync();

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll, { passive: true });

        this.$watch('$store.app.isMobile', () => this.sync());
    },

    destroy() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);

        if (this.scrollFrame) {
            cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = null;
        }
    },

    scheduleSync() {
        if (this.scrollFrame) {
            return;
        }

        this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.sync();
        });
    },

    sync() {
        this.visible = this.$store.app.isMobile
            && this.getScrollY() >= window.innerHeight
            && !this.isFooterInViewport();
    },

    getScrollY() {
        return window.pageYOffset || document.documentElement.scrollTop || 0;
    },

    isFooterInViewport() {
        if (!this.footer) {
            return false;
        }

        const rect = this.footer.getBoundingClientRect();

        return rect.top <= window.innerHeight && rect.bottom >= 0;
    },
});
